import { Link } from '@tanstack/react-router';
import { Container } from '@/components/ui/container';
import { Button } from '@/components/ui/button';
import { Sticker } from '@/components/ui/sticker';

export function NotFound() {
  return (
    <Container className="flex min-h-[62vh] flex-col items-center justify-center gap-6 text-center">
      <p className="text-gradient text-8xl font-semibold tracking-tight">404</p>
      <Sticker flavor="grape" rotate={-3}>
        page not found
      </Sticker>
      <p className="max-w-sm text-ink-soft">
        That page doesn&apos;t exist yet. If you were expecting it, add a route in{' '}
        <code className="font-mono text-sm">src/app/router.tsx</code>.
      </p>
      <Button asChild variant="candy">
        <Link to="/">Back home</Link>
      </Button>
    </Container>
  );
}
